import { ref } from 'vue'
import axios from 'axios'
import { showFailToast } from 'vant'
import { loading } from '@/utils/loading'
import { useUserStore } from '@/stores/user'

const instance = axios.create()

instance.defaults.baseURL = import.meta.env.VITE_APP_API_BASE_URL_SANKE
instance.defaults.withCredentials = false
instance.defaults.timeout = 30000

const count = ref(0)
let timmer: number = -1

function hideLoading() {
  timmer = window.setTimeout(() => {
    if (count.value === 0) {
      loading.hide()
    }
  }, 16)
}

function setRequestCount() {
  if (count.value > 0) {
    count.value--
  } else {
    count.value = 0
  }
  hideLoading()
}

instance.interceptors.request.use((config) => {
  const { userInfo, requestHeader } = useUserStore()
  const { token } = userInfo

  if (config.loadingShow === '1') {
    clearTimeout(timmer)
    loading.show()
    count.value++
  }

  if (!config.isCustomRequestParams) {
    if (config.method === 'post') {
      config.data = {
        parameter: config?.data || {},
        sessionid: token
      }
    }
    if (config.method === 'get') {
      config.params = {
        parameter: config?.params || {},
        sessionid: token
      }
    }
  }

  try {
    // eslint-disable-next-line
    for (let [key, value] of Object.entries(requestHeader)) {
      if (typeof value === 'string' && /[\u4e00-\u9fa5]/.test(value)) {
        value = encodeURIComponent(value)
      }
      if (key !== 'Device-Name') {
        config.headers[key] = value
      }
    }
  } catch (error) {
    console.log('requestHeader', error)
  }
  return config
})

instance.interceptors.response.use(
  async (res) => {
    if (res.config?.loadingShow === '1') {
      setRequestCount()
    }
    // const { code, desc } = res.data

    // if (res.config.toastShow === '1') {
    // if (code !== 20000 && desc) {
    //   showFailToast(desc)
    // }
    // }

    return Promise.resolve(res.data || {})
  },
  (error) => {
    // if (error.config?.loadingShow !== '0') {
    count.value = 0
    hideLoading()
    // }

    return Promise.resolve(error || {})
  }
)

export const LANG_LIST_UP: any = {
  zh: 'CN',
  cn: 'CN',
  en: 'EN',
  my: 'MY'
}

const Handle = (code: any, msg: any) => {
  switch (code) {
    case 401: // "认证失败，请先登录"
    case 151000006: // "认证失败，请先登录"
      // loginOut(msg)
      showFailToast(msg)
      break
    case 500:
      showFailToast('服务器错误')
      break
    default:
      showFailToast(msg)
      break
  }
}

// 转换表单---目前是马来散客
export const FetchFrom = (
  methods: any,
  params: any,
  allowCodes: number[] = []
) =>
  new Promise((resolve, reject) => {
    const { userInfo, requestHeader } = useUserStore()
    const { token, langType } = userInfo
    // const { token } = useUserStore()
    const formData = new FormData()
    formData.append('method', methods)
    formData.append('data', JSON.stringify(params))
    // 语言
    formData.append('langType', langType)
    formData.append('lang', langType)
    formData.append('platform', requestHeader?.platform)

    const baseUrl =
      localStorage.getItem('envUrl') ||
      import.meta.env.VITE_APP_API_BASE_URL_SANKE
    console.log('baseUrl', baseUrl)
    formData.append('sessionid', token || 'session_e775f8a08270c947')
    axios({
      url: `${baseUrl}/jandt-app-ifd-web/router.do`,
      // url: `/api/jandt-app-ifd-web/router.do`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Access-Control-Allow-Origin': '*'
      },
      data: formData
    })
      .then((res) => {
        const { data } = res || {}
        // 请求接口异常直接提示报错
        const { code, desc } = data || {}
        const isAllowedCode = allowCodes.includes(code)
        if (code !== 200) {
          if (isAllowedCode) {
            return resolve(data?.data ? JSON.parse(data?.data) : data)
          }
          Handle(code, desc)
          return reject(data)
        }
        // console.log('data', data)
        resolve(data?.data ? JSON.parse(data?.data) : null)
      })
      .catch((error) => {
        reject(error)
      })
  })

export default instance
